import {
  CHANGE_CLIENT_SHORT_INFO_FAILED,
  CHANGE_CLIENT_SHORT_INFO_REQUESTED,
  CHANGE_CLIENT_SHORT_INFO_SUCCESS,
  GET_CLIENT_DETAILS_FAILED,
  GET_CLIENT_DETAILS_REQUEST,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_SHORT_CASHBOXES_LIST_FAILED,
  GET_SHORT_CASHBOXES_LIST_SUCCESS,
  GET_SHORT_CASHBOXES_REQUESTED,
  GET_SHORT_INFO_FAILED,
  GET_SHORT_INFO_REQUESTED,
  GET_SHORT_INFO_SUCCESS,
  ACCESS_TO_CONTRACT_CREATION_ERROR,
  SHORT_INFO_RESET,
} from '../actions/actionTypes';
import _cloneDeep from 'lodash/cloneDeep'

const initialState = {
  cashBoxes: [],
  client: {},
  isLoading: false,
  commonError: '',
}

const clientShortInfoReducer = (state = _cloneDeep(initialState), action ) => {
  switch (action.type) {
    case GET_SHORT_INFO_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_SHORT_INFO_SUCCESS:
      return {
        ...state,
        client: {...state.client, ...action.payload},
        isLoading: false,
        commonError: '',
      }
    case GET_SHORT_INFO_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_SHORT_CASHBOXES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_SHORT_CASHBOXES_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cashBoxes: action.payload
      }
    case GET_SHORT_CASHBOXES_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case CHANGE_CLIENT_SHORT_INFO_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: '',
      }
    case CHANGE_CLIENT_SHORT_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        client: {...state.client, ...action.payload}
      }
    case CHANGE_CLIENT_SHORT_INFO_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_CLIENT_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_CLIENT_DETAILS_SUCCESS:
      return {
        ...state,
        client: {...state.client, ...action.payload},
        isLoading: false,
        commonError: ''
      }
    case GET_CLIENT_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case ACCESS_TO_CONTRACT_CREATION_ERROR:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case SHORT_INFO_RESET:
      return _cloneDeep(initialState)
    default:
      return state
  }
}

export default clientShortInfoReducer
